import type { Pair } from '../messages';
import { ruPlural } from '../plural';

/** Labels for saved-link types, visibility and the four personal statuses (slice 2). */
export const labels = {
  'type.movie': ['Фильм', 'Film'],
  'type.series': ['Сериал', 'Series'],
  'type.book': ['Книга', 'Book'],
  'type.game': ['Игра', 'Game'],
  'type.course': ['Курс', 'Course'],
  'type.article': ['Статья', 'Article'],
  'type.recipe': ['Рецепт', 'Recipe'],
  'type.video': ['Видео', 'Video'],
  'type.document': ['Документ', 'Document'],
  'type.website': ['Сайт', 'Site'],
  'type.other': ['Ссылка', 'Link'],
  'vis.private': ['Приватная', 'Private'],
  'vis.followers': ['Для подписчиков', 'For followers'],
  'vis.public': ['Публичная', 'Public'],
  'vis.private.hint': ['Только вы', 'Only you'],
  'vis.followers.hint': ['Вы и те, кто на вас подписан', 'You and your followers'],
  'vis.public.hint': ['Все, кто знает ссылку', 'Anyone with the link'],
  'status.read.wishlist': ['Хочу прочитать', 'Want to read'],
  'status.read.active': ['Читаю', 'Reading'],
  'status.read.done': ['Прочитано', 'Read'],
  'status.read.dropped': ['Брошено', 'Dropped'],
  'status.watch.wishlist': ['Хочу посмотреть', 'Want to watch'],
  'status.watch.active': ['Смотрю', 'Watching'],
  'status.watch.done': ['Просмотрено', 'Watched'],
  'status.watch.dropped': ['Брошено', 'Dropped'],
  'status.play.wishlist': ['Хочу сыграть', 'Want to play'],
  'status.play.active': ['Играю', 'Playing'],
  'status.play.done': ['Пройдено', 'Completed'],
  'status.play.dropped': ['Брошено', 'Dropped'],
  'status.cook.wishlist': ['Хочу приготовить', 'Want to cook'],
  'status.cook.active': ['Готовлю', 'Cooking'],
  'status.cook.done': ['Приготовлено', 'Cooked'],
  'status.cook.dropped': ['Брошено', 'Dropped'],
  'status.save.wishlist': ['Хочу сохранить', 'Want to save'],
  'status.save.active': ['В процессе', 'In progress'],
  'status.save.done': ['Готово', 'Done'],
  'status.save.dropped': ['Отложено', 'Set aside'],
} satisfies Record<string, Pair>;

/**
 * Counted and relative phrases. Russian needs its three plural forms, English one switch — that is
 * why a message can be a function of `{n}` instead of a plain string.
 */
export const times = {
  'time.now': ['только что', 'just now'],
  'time.yesterday': ['вчера', 'yesterday'],
  'time.minute': [
    (v) => `${ruPlural(+v.n, 'минуту', 'минуты', 'минут')} назад`,
    (v) => (+v.n === 1 ? 'a minute ago' : `${v.n} minutes ago`),
  ],
  'time.hour': [
    (v) => `${ruPlural(+v.n, 'час', 'часа', 'часов')} назад`,
    (v) => (+v.n === 1 ? 'an hour ago' : `${v.n} hours ago`),
  ],
  'time.day': [
    (v) => `${ruPlural(+v.n, 'день', 'дня', 'дней')} назад`,
    (v) => (+v.n === 1 ? 'a day ago' : `${v.n} days ago`),
  ],
  'count.items': [
    (v) => ruPlural(+v.n, 'элемент', 'элемента', 'элементов'),
    (v) => (+v.n === 1 ? '1 item' : `${v.n} items`),
  ],
} satisfies Record<string, Pair>;
